import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../i18n";
import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import SelectRoom from "../views/SelectRoom.vue";
import Payment from "../views/Payment.vue";
import Confirmation from "../views/Confirmation.vue";
import Information from "../views/Information.vue";
import Error from "../views/Error.vue";
import Login from "../views/Login.vue";
import ResetPassword from "../views/ResetPassword.vue";
import ChangePassword from "../views/ChangePassword.vue";
import UserCenter from "../views/UserCenter.vue";
import TermsOfUse from "../views/TermsOfUse.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import CustomerServices from "../views/CustomerServices.vue";
import Refresh from "../views/Refresh.vue";
import store from "../store/index.js";

Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "title:Hotel Online Reservations",
      sjmTitle: "sjmTitle:Hotel Online Reservations",
      glTitle: "glTitle:Hotel Online Reservations"
    }
  },
  {
    path: "/booking-search",
    name: "Search",
    component: Search,
    meta: {
      title: "title:Booking Search",
      sjmTitle: "sjmTitle:Booking Search",
      glTitle: "glTitle:Booking Search"
    }
  },
  {
    path: "/select-room",
    name: "SelectRoom",
    component: SelectRoom,
    meta: {
      title: "title:Select Room",
      sjmTitle: "sjmTitle:Select Room",
      glTitle: "glTitle:Select Room"
    }
  },
  {
    path: "/payment",
    name: "Payment",
    component: Payment,
    meta: {
      title: "title:Payment",
      sjmTitle: "sjmTitle:Payment",
      glTitle: "glTitle:Payment"
    }
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: Confirmation,
    meta: {
      title: "title:Confirmation",
      sjmTitle: "sjmTitle:Confirmation",
      glTitle: "glTitle:Confirmation"
    }
  },
  {
    path: "/book-information",
    name: "Information",
    component: Information,
    meta: {
      title: "title:My Booking Information",
      sjmTitle: "sjmTitle:My Booking Information",
      glTitle: "glTitle:My Booking Information"
    }
  },
  {
    path: "/404",
    name: "page-error",
    component: Error,
    meta: {
      title: "title:Page not found",
      sjmTitle: "sjmTitle:Page not found",
      glTitle: "glTitle:Page not found"
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "title:Login",
      sjmTitle: "sjmTitle:Login",
      glTitle: "glTitle:Login"
    }
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      title: "title:Reset Password",
      sjmTitle: "sjmTitle:Reset Password",
      glTitle: "glTitle:Reset Password"
    }
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: {
      title: "title:Reset Password",
      sjmTitle: "sjmTitle:Reset Password",
      glTitle: "glTitle:Reset Password"
    }
  },
  {
    path: "/user-center",
    name: "UserCenter",
    component: UserCenter,
    meta: {
      title: "title:User Center",
      sjmTitle: "sjmTitle:User Center",
      glTitle: "glTitle:User Center"
    }
  },
  {
    path: "/terms-of-use",
    name: "TermsOfUse",
    component: TermsOfUse,
    meta: {
      title: "title:Terms of Use",
      sjmTitle: "sjmTitle:Terms of Use",
      glTitle: "glTitle:Terms of Use"
    }
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      title: "title:Privacy Policy",
      sjmTitle: "sjmTitle:Privacy Policy",
      glTitle: "glTitle:Privacy Policy"
    }
  },
  {
    path: "/CustomerServices",
    name: "CustomerServices",
    component: CustomerServices,
    meta: {
      title: "Customer Services",
      sjmTitle: "Customer Services",
      glTitle: "Customer Services"
    }
  },
  {
    name: "refresh",
    path: "/refresh",
    component: Refresh
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

router.beforeEach((to, from, next) => {
  const skinArr = ["sjm", "glp", "gl"];
  const langArr = ["en", "cn", "tc", "jap", "ko"];
  const querySkin = skinArr.find(x => x === to.query.skin);
  const localSkin = skinArr.find(x => x === localStorage.skinCode);
  const queryLang = langArr.find(x => x === to.query.lang);
  const localLang = langArr.find(x => x === localStorage.lang);

  if (querySkin) {
    to.query.skin = querySkin;
    localStorage.skinCode = querySkin;
  } else if (localSkin) {
    to.query.skin = localSkin;
  } else {
    to.query.skin = "sjm";
    localStorage.skinCode = "sjm";
  }

  if (queryLang) {
    to.query.lang = queryLang;
    localStorage.lang = queryLang;
    i18n.locale = queryLang;
  } else if (localLang) {
    to.query.lang = localLang;
    i18n.locale = localLang;
  } else {
    to.query.lang = "tc";
    localStorage.lang = "tc";
    i18n.locale = "tc";
  }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    store.commit("stateChange", {
      k: "gaData",
      v: Object.assign({}, store.gaData, {
        skinCode: localStorage.getItem("skinCode")
      })
    });

    if (store.state.gaData.skinCode === "sjm") {
      document.title = i18n.t(to.meta.sjmTitle);
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}sjmfavicon.ico`;
    } else if (store.state.gaData.skinCode === "gl") {
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}glfavicon.ico`;
      document.title = i18n.t(to.meta.glTitle);
    } else {
      document.querySelector(
        '[rel="icon"]'
      ).href = `${process.env.BASE_URL}glpfavicon.ico`;
      document.title = i18n.t(to.meta.title);
    }
  }

  if (to.matched.length === 0) {
    from.name
      ? next({
          name: from.name
        })
      : next({ name: "page-error" });
  } else {
    if (!queryLang || (!querySkin && to.name !== "refresh")) {
      next({
        path: to.path,
        query: {
          ...to.query
        }
      });
    }
    //如果匹配到正确跳转
    next();
  }
});

export default router;
